import React from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import Vision from "../../Images/visin.png";
import Expertise from "../../Images/expertise.png";
import Growth from "../../Images/growth.png";
import "../.././App.css";

const founderMessage = () => {
  return (
    <div>
      <Header />
      <section
        className="relative py-12 sm:py-20"
        style={{
          background: "linear-gradient(to bottom , #c99c48 30%, #8b7035 100%)",
        }}
      >
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="pt-[6rem] pb-8">
              <div className="container mx-auto px-4 sm:px-6">
                <div className="text-center mb-8" data-aos="fade-up">
                  <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-black mb-4">
                    Message from the
                  </h1>
                  <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-black mb-6">
                    Founder
                  </h1>
                  <div className="w-16 sm:w-24 h-1 bg-black mx-auto"></div>
                </div>
              </div>
            </div>
            <div
              className="grid gap-12 lg:grid-cols-2 items-center"
              data-aos="fade-right"
            >
              {/* Founder Image */}
              <div className="order-2 lg:order-1">
                <div className="relative">
                  <div className="absolute inset-0 bg-black transform rotate-3 rounded-lg"></div>
                  <div className="relative bg-white p-6 sm:p-8 rounded-lg shadow-2xl">
                    <div className="w-full h-80 sm:h-96 bg-gray-200 rounded-lg mb-6 flex items-center justify-center">
                      <div className="text-gray-400 text-center">
                        <div className="w-20 h-20 bg-gray-300 rounded-full mx-auto mb-4 flex items-center justify-center">
                          <span className="text-2xl font-bold text-gray-500">SS</span>
                        </div>
                        <p className="text-sm">Sabeel Sajid</p>
                      </div>
                    </div>
                    <div className="text-center">
                      <h3 className="text-xl sm:text-2xl font-bold text-black mb-2">
                        Sabeel Sajid
                      </h3>
                      <p className="text-gray-800 mb-1">
                        Founder & General Manager
                      </p>
                      <p className="text-gray-800 mb-1">Strategic Advisor</p>
                      <p className="text-gray-800 mb-1">
                        Investment Evangelist
                      </p>
                      <p className="text-gray-800">Diplomatic Facilitator</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Message Content */}
              <div className="order-1 lg:order-2">
                <div className="prose prose-lg max-w-none">
                  <h2 className="text-2xl sm:text-3xl font-bold text-black mb-6 sm:mb-8">
                    Welcome to Semars Holding
                  </h2>
                  <div className="space-y-3 md:space-y-5 text-black font-normal text-md md:text-lg">
                    <p>
                      It is with immense pride and purpose that I present to you
                      our platform—an institution born from decades of global
                      experience...
                    </p>
                    <p>
                      As someone who has spent over 20 years advising on
                      high-stakes investments, defense strategy...
                    </p>
                    <p>
                      Semars Holding is more than an advisory firm. It is a
                      vehicle for empowerment...
                    </p>
                    <p>
                      Whether it is enabling localization in semiconductor
                      manufacturing, advising on green investments...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Team Section */}
      <section
        className="relative py-16 sm:py-20"
        style={{
          background: "linear-gradient(to bottom , #c99c48 30%, #8b7035 100%)",
        }}
      >
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12" data-aos="fade-up">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-4">
                Leadership Team
              </h2>
              <div className="w-16 sm:w-24 h-1 bg-[#c99c48] mx-auto"></div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
              {/* Captain Ferouze */}
              <div className="bg-white rounded-lg shadow-xl p-6 sm:p-8" data-aos="fade-up" data-aos-delay="100">
                <div className="relative">
                  <div className="absolute inset-0 bg-[#c99c48] transform rotate-1 rounded-lg"></div>
                  <div className="relative bg-white p-6 rounded-lg">
                    <div className="w-full h-64 bg-gray-200 rounded-lg mb-6 flex items-center justify-center">
                      <div className="text-gray-400 text-center">
                        <div className="w-20 h-20 bg-gray-300 rounded-full mx-auto mb-4 flex items-center justify-center">
                          <span className="text-2xl font-bold text-gray-500">CF</span>
                        </div>
                        <p className="text-sm">Captain Ferouze</p>
                      </div>
                    </div>
                    <div className="text-center">
                      <h3 className="text-xl sm:text-2xl font-bold text-black mb-2">
                        Captain Ferouze
                      </h3>
                      <p className="text-gray-800 mb-1 font-semibold">
                        Global Business Development Consultant
                      </p>
                      <p className="text-gray-600 text-sm">
                        Specialist in aviation and defense contracts across the GCC with deep ties to OEMs and Tier 1 suppliers. Full Member of the UK Chartered Institute of International Trade & Exports (MCIEx).
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mr. Umair Bass */}
              <div className="bg-white rounded-lg shadow-xl p-6 sm:p-8" data-aos="fade-up" data-aos-delay="200">
                <div className="relative">
                  <div className="absolute inset-0 bg-[#c99c48] transform rotate-1 rounded-lg"></div>
                  <div className="relative bg-white p-6 rounded-lg">
                    <div className="w-full h-64 bg-gray-200 rounded-lg mb-6 flex items-center justify-center">
                      <div className="text-gray-400 text-center">
                        <div className="w-20 h-20 bg-gray-300 rounded-full mx-auto mb-4 flex items-center justify-center">
                          <span className="text-2xl font-bold text-gray-500">UB</span>
                        </div>
                        <p className="text-sm">Mr. Umair Bass</p>
                      </div>
                    </div>
                    <div className="text-center">
                      <h3 className="text-xl sm:text-2xl font-bold text-black mb-2">
                        Mr. Umair Bass
                      </h3>
                      <p className="text-gray-800 mb-1 font-semibold">
                        Real Estate & Commercial Consultant
                      </p>
                      <p className="text-gray-600 text-sm">
                        Over 10 years of experience in Saudi Arabia's mega and giga projects, BOT models, and public-private partnerships for government and private developments.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mr. Asim */}
              <div className="bg-white rounded-lg shadow-xl p-6 sm:p-8" data-aos="fade-up" data-aos-delay="300">
                <div className="relative">
                  <div className="absolute inset-0 bg-[#c99c48] transform rotate-1 rounded-lg"></div>
                  <div className="relative bg-white p-6 rounded-lg">
                    <div className="w-full h-64 bg-gray-200 rounded-lg mb-6 flex items-center justify-center">
                      <div className="text-gray-400 text-center">
                        <div className="w-20 h-20 bg-gray-300 rounded-full mx-auto mb-4 flex items-center justify-center">
                          <span className="text-2xl font-bold text-gray-500">A</span>
                        </div>
                        <p className="text-sm">Mr. Asim</p>
                      </div>
                    </div>
                    <div className="text-center">
                      <h3 className="text-xl sm:text-2xl font-bold text-black mb-2">
                        Mr. Asim
                      </h3>
                      <p className="text-gray-800 mb-1 font-semibold">
                        In-Kingdom Business Setup & Telecom Consultant
                      </p>
                      <p className="text-gray-600 text-sm">
                        15+ years of experience in commercial legal advisory and telecom-sector business structuring within Saudi Arabia.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mr. Zian Abas */}
              <div className="bg-white rounded-lg shadow-xl p-6 sm:p-8" data-aos="fade-up" data-aos-delay="400">
                <div className="relative">
                  <div className="absolute inset-0 bg-[#c99c48] transform rotate-1 rounded-lg"></div>
                  <div className="relative bg-white p-6 rounded-lg">
                    <div className="w-full h-64 bg-gray-200 rounded-lg mb-6 flex items-center justify-center">
                      <div className="text-gray-400 text-center">
                        <div className="w-20 h-20 bg-gray-300 rounded-full mx-auto mb-4 flex items-center justify-center">
                          <span className="text-2xl font-bold text-gray-500">ZA</span>
                        </div>
                        <p className="text-sm">Mr. Zian Abas</p>
                      </div>
                    </div>
                    <div className="text-center">
                      <h3 className="text-xl sm:text-2xl font-bold text-black mb-2">
                        Mr. Zian Abas
                      </h3>
                      <p className="text-gray-800 mb-1 font-semibold">
                        VAT & Tax Consultant
                      </p>
                      <p className="text-gray-600 text-sm">
                        Expert in VAT compliance, taxation, and financial advisory, providing seamless solutions for market entry and relocation in the Kingdom.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="relative bg-[#333333] py-16 sm:py-20">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center" data-aos="fade-up">
            <blockquote className="text-xl sm:text-2xl lg:text-3xl font-light text-white mb-8 italic leading-relaxed">
              "We do this through trust, precision, and relationships—not just
              with regulators and ministries..."
            </blockquote>
            <div className="w-16 sm:w-24 h-1 bg-white mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Vision 2030 Section */}
      <section
        className="relative py-16 sm:py-20"
        style={{
          background:
            "linear-gradient(to bottom, #c99c48 0%, #8b7035 50%, #4a4a4a 100%)",
        }}
      >
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-6xl mx-auto text-center" data-aos="fade-up">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-8">
              Aligned with Vision 2030
            </h2>
            <p className="text-base sm:text-lg text-gray-100 mb-10 sm:mb-12 max-w-3xl mx-auto">
              Participating in Saudi Arabia's historic transformation through
              strategic partnerships, innovative solutions, and sustainable
              growth initiatives.
            </p>

            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 mt-10">
              {[
                {
                  title: "Strategic Vision",
                  desc: "Decades of global experience in high-stakes investments and cross-border diplomacy",
                  image: Vision,
                },
                {
                  title: "Local Expertise",
                  desc: "Deep relationships with institutions, families, and key stakeholders across the Kingdom",
                  image: Expertise,
                },
                {
                  title: "Sustainable Growth",
                  desc: "Unlocking value through trust, precision, and enduring partnerships",
                  image: Growth,
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6 text-center transition-all duration-300 transform hover:-translate-y-2 hover:scale-105 hover:shadow-lg border border-white/10"
                >
                  <div className="w-14 h-14 sm:w-16 sm:h-16 bg-transparent flex items-center justify-center mx-auto mb-4 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-3">
                    {item.title}
                  </h3>
                  <p className="text-gray-100 text-sm sm:text-base">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default founderMessage;
